/**
 * Cliente do registro da mesa: dia, turno, localização, notas e os dados.
 *
 * <p>O dado é rolado <b>no servidor</b>. Um sorteio no navegador é um sorteio que se
 * repete até gostar do número — e numa mesa isso não é detalhe técnico.
 */
import { api } from '../../api/cliente';

const BASE = '/api/projetos/mistik-island/mistik-dream/registro';

/** A última rolagem de um jogador, sob o handle dele. */
export interface Rolagem {
  valor: number;
  em: string;
}

export interface Registro {
  conteudo: {
    dia?: number;
    turno?: number;
    localizacao?: string;
    notas?: string;
    rolagens?: Record<string, Rolagem>;
  };
  versao: number;
  atualizadoPor?: string;
  atualizadoEm?: string;
}

export const CHAVE_DO_REGISTRO = ['mistik-dream', 'registro'] as const;

export function ler(): Promise<Registro> {
  return api<Registro>(BASE);
}

/**
 * Grava dia, turno, localização e notas. Só o mestre passa.
 *
 * <p>As rolagens não vão no corpo: elas são de quem rolou, e o servidor preserva as que
 * estão gravadas. Mandá-las daqui deixaria o mestre reescrever o dado dos outros ao
 * salvar a localização.
 */
export function salvar(conteudo: Registro['conteudo'], versaoBase: number): Promise<Registro> {
  return api<Registro>(BASE, { method: 'PUT', body: JSON.stringify({ conteudo, versaoBase }) });
}

/** Rola o d12 de quem chamou. Qualquer um rola — o dele. */
export function rolar(): Promise<Registro> {
  return api<Registro>(`${BASE}/rolar`, { method: 'POST' });
}
